import React, { memo } from 'react'
import { faExclamationCircle } from '@fortawesome/pro-duotone-svg-icons'

import FailedStatus from '../common/FailedStatus'
import customConfig from 'customConfig'

const CodeExpired = ({ onSubmit, t }) => (
  <FailedStatus
    title={t('overview.code-expired')}
    description={t(customConfig.rewardCodeAlreadyExpired)}
    icon={faExclamationCircle}
    onSubmit={onSubmit}
    t={t}
  />
)

export default memo(CodeExpired)
